import datapoints from './datapoints';
import undoStore from '../store/undoStore';
import tombstoneOperations from 'owa-mail-list-tombstone';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Only supporting a "stack" of one (last undoable action)
 */
var lastUndoableAction;
/**
 * Initialize the undoStack
 */
export var addActionToUndoStack = action('addActionToUndoStack')(select({
    store: function () { return undoStore; },
})(function addActionToUndoStack(action, state) {
    if (action !== null) {
        lastUndoableAction = action;
        state.store.hasUndoableAction = true;
    }
}));
/**
 * Gets last undoable action
 * @return Last undoable action
 */
export var getLastUndoableAction = function getLastUndoableAction() {
    return lastUndoableAction;
};
/**
 * Clears last undoable action (to null)
 */
export var clearLastUndoableAction = action('clearLastUndoableAction')(select({
    store: function () { return undoStore; },
})(function clearLastUndoableAction(state) {
    lastUndoableAction = null;
    state.store.hasUndoableAction = false;
}));
/**
 * Returns if last undoable action is empty
 * @return If last undoable action is empty
 */
export var hasUndoableAction = select({
    store: function () { return undoStore; },
})(function hasUndoableAction(state) {
    return state.store.hasUndoableAction;
});
/**
 * Undos the last undoable action (if it exists).
 */
export var undo = action('undo', datapoints.undoDatapoint)(function undo(actionSource) {
    // Need to remove everything from tombstone because if the action is being performed on a row that is
    // in tombstone then we will not honor the row notification when the action gets undone so row won't come back.
    tombstoneOperations.removeAll();
    var lastUndoableAction = getLastUndoableAction();
    // lastUndoableAction can be null if lazy loading of undo doesn't finish before user performs another action
    // that clears the undo stack.
    if (lastUndoableAction !== null) {
        // Perform undo
        lastUndoableAction();
        // Must clear stack so user can't try to undo same action again. Also clears UI.
        clearLastUndoableAction();
    }
});
//# sourceMappingURL=undoActions.js.map